import styled from "styled-components"
import { Card, Grid } from "semantic-ui-react"

export const FullScreenOverlay = styled.div`
  position: absolute !important;
  top: -100px;
  left: -100px;
  z-index: 10;
  width: calc(100vw + 100px);
  height: calc(100vh + 100px);
  background-color: #e4e4e4;
`

export const MinicourseCard = styled(Card)`
  min-height: 27em !important;

  p {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .extra.content {
    padding: 16px !important;
  }

  .ui.cards:after,
  .ui.card:after {
    height: auto !important;
    visibility: visible !important;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: none;
    transition: all 0.3s linear;
  }
  &:hover:after {
    background: rgba(0, 0, 0, 0.1);
    pointer-events: none;
  }
  &:hover div {
    opacity: 1;
  }
`

export const AltLayoutGrid = styled(Grid)`
  padding: 16px !important;
`
